import { PYTHON_API_BASE_URL } from "../../../services/api/apiConstants";
import { encryptPassword } from "../../../encryption";

function buildHeaders({ accessToken, userId }) {
  return {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json",
    "X-User-ID": userId || "",
  };
}

export async function fetchBranches({ accessToken, email, jobTitle, userId, organizationId }) {
  const endpoint = `${PYTHON_API_BASE_URL}/organizations/${organizationId}/branches/`;
    // jobTitle === "Branch Admin"
    //   ? `${PYTHON_API_BASE_URL}/branches-for-branch-admin/?email=${email}`
    //   : `${PYTHON_API_BASE_URL}/branches-for-admin/?email=${email}`;

  const response = await fetch(endpoint, {
    method: "GET",
    headers: buildHeaders({ accessToken, userId }),
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch branches: ${response.status}`);
  }

  return response.json();
}

export async function fetchBranchStats({ accessToken, branchId, userId }) {
  const endpoint = `${PYTHON_API_BASE_URL}/admin/branch-stats/?branch_id=${branchId}`;

  const response = await fetch(endpoint, {
    method: "GET",
    headers: buildHeaders({ accessToken, userId }),
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch branch stats: ${response.status}`);
  }

  return response.json();
}

export async function updateBranch({ accessToken, userId, branchId, formData }) {
  const response = await fetch(`${PYTHON_API_BASE_URL}/branches/${branchId}/`, {
    method: "PUT",
    headers: buildHeaders({ accessToken, userId }),
    body: JSON.stringify({
      branch_name: formData.branchName,
      address_line: formData.addressLine,
      city: formData.city,
      state: formData.state,
      country: formData.country,
      zip_code: formData.zipCode,
    }),
  });

  const data = await response.json();

  if (!response.ok) {
    let errorMsg = "Failed to update branch. Please try again.";
    if (typeof data.error === "string") {
      errorMsg = data.error;
    } else if (data.error?.message) {
      errorMsg = data.error.message;
    }
    throw new Error(errorMsg);
  }

  return data;
}

export async function createBranch({ accessToken, userId, organizationId, formData }) {
  const response = await fetch(`${PYTHON_API_BASE_URL}/branches/`, {
    method: "POST",
    headers: buildHeaders({ accessToken, userId }),
    body: JSON.stringify({
      branch_name: formData.branchName,
      address_line: formData.addressLine,
      city: formData.city,
      state: formData.state,
      country: formData.country,
      zip_code: formData.zipCode,
      branch_admin_first_name: formData.firstName,
      branch_admin_last_name: formData.lastName,
      branch_admin_email: formData.email,
      branch_admin_phone: formData.phone,
      password: encryptPassword(formData.password),
      org_id: organizationId,
    }),
  });

  const data = await response.json();

  if (!response.ok) {
    let errorMsg = "Failed to register branch. Please try again.";
    if (typeof data.error === "string") {
      const storageMatch = data.error.match(/Storage Account .* already exists/i);
      if (storageMatch) {
        errorMsg = "Storage account Name already exists";
      } else {
        const parts = data.error.split(":");
        errorMsg = parts[parts.length - 1].trim();
      }
    } else if (data.error?.message) {
      errorMsg = data.error.message;
    }
    throw new Error(errorMsg);
  }

  return data;
}
